import { Link } from "react-router-dom";
import { Mail, Twitter, Facebook, Youtube, Newspaper } from "lucide-react";

export default function Footer({ onOpenBrief, onOpenSponsor }) {
  return (
    <footer className="mt-16 bg-[var(--ink)] text-white">
      <div className="max-w-[1280px] mx-auto px-5 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 md:col-span-2">
          <div className="flex items-center gap-3 mb-3">
            <span className="logo"><Newspaper size={22} /></span>
            <span className="text-[24px] font-black tracking-[-0.03em]">Newseze</span>
          </div>
          <p className="text-[14px] text-white/70 leading-relaxed max-w-[360px]">
            Balanced news. Calm headlines. Trusted ranking. Newseze surfaces what matters
            from a balanced mix of major newsrooms — outrage filtered, signals first.
          </p>
          <div className="flex gap-2 mt-5">
            <button className="btn ghost" onClick={onOpenBrief} data-testid="footer-brief-cta">
              <Mail size={14} /> My Daily Brief
            </button>
            <button className="btn ghost" onClick={onOpenSponsor} data-testid="footer-sponsor-cta">
              Become a sponsor
            </button>
          </div>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-[0.16em] font-bold text-white/60 mb-3">Sections</div>
          <ul className="space-y-2 text-[14px] text-white/85">
            <li><Link to="/section/government" className="hover:text-[var(--gold)]">Politics</Link></li>
            <li><Link to="/section/economy" className="hover:text-[var(--gold)]">Business</Link></li>
            <li><Link to="/section/markets" className="hover:text-[var(--gold)]">Markets</Link></li>
            <li><Link to="/section/world" className="hover:text-[var(--gold)]">World</Link></li>
            <li><Link to="/section/technology" className="hover:text-[var(--gold)]">Tech</Link></li>
            <li><Link to="/section/health" className="hover:text-[var(--gold)]">Health</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-[0.16em] font-bold text-white/60 mb-3">Channels</div>
          <ul className="space-y-2 text-[14px] text-white/85">
            <li><Link to="/section/videos" className="hover:text-[var(--gold)]">Video</Link></li>
            <li><Link to="/section/podcasts" className="hover:text-[var(--gold)]">Investigations Podcast</Link></li>
            <li><button onClick={onOpenBrief} className="hover:text-[var(--gold)] text-left">My Daily Brief (Email)</button></li>
            <li><button onClick={onOpenBrief} className="hover:text-[var(--gold)] text-left">My Daily Brief (Text)</button></li>
          </ul>
        </div>

        <div>
          <div className="text-[12px] uppercase tracking-[0.16em] font-bold text-white/60 mb-3">Company</div>
          <ul className="space-y-2 text-[14px] text-white/85">
            <li><Link to="/trust" className="hover:text-[var(--gold)]">Editorial Trust</Link></li>
            <li><Link to="/newsroom" className="hover:text-[var(--gold)]">The Newsroom</Link></li>
            <li><button onClick={onOpenSponsor} className="hover:text-[var(--gold)] text-left">Advertise</button></li>
            <li><button onClick={onOpenSponsor} className="hover:text-[var(--gold)] text-left">Sponsor a section</button></li>
            <li><Link to="/contact" className="hover:text-[var(--gold)]">Contact</Link></li>
            <li><Link to="/archives" className="hover:text-[var(--gold)]">Archives</Link></li>
            <li><Link to="/rewards" className="hover:text-[var(--gold)]">Rewards</Link></li>
            <li><Link to="/legal" className="hover:text-[var(--gold)]">Legal · DMCA</Link></li>
            <li><Link to="/security" className="hover:text-[var(--gold)] flex items-center gap-1" data-testid="footer-security-link">Security Posture <span className="text-[var(--gold)] text-[10px]">NEW</span></Link></li>
            <li><Link to="/admin" className="hover:text-[var(--gold)]">Operator</Link></li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a className="text-white/70 hover:text-white" href="#" aria-label="X"><Twitter size={18} /></a>
            <a className="text-white/70 hover:text-white" href="#" aria-label="Facebook"><Facebook size={18} /></a>
            <a className="text-white/70 hover:text-white" href="#" aria-label="YouTube"><Youtube size={18} /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-5 py-5 text-[12px] text-white/55 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Newseze. All rights reserved.</span>
          <span>Curated wire · Trust-ranked · Outrage filtered.</span>
        </div>
      </div>
    </footer>
  );
}
